import { Configuration as ConfSaci, SaciApi } from '@conacyt/saci-client';

const saciConfiguration = new ConfSaci({
  basePath: '/services/saci',
});

const saciApi = new SaciApi(saciConfiguration);

export { saciApi };
